// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * I-9 Compliance application registration.
 */
import { registerApplication } from '../../core/layout-registry'
import { I9UserView } from './components/UserView'
import { I9AdminView } from './components/AdminView'

registerApplication({
  id: 'i9',
  name: 'I-9 Compliance',
  description: 'I-9 form verification with vision extraction and UMD matching',
  components: [
    {
      id: 'applications/i9',
      label: 'I-9 Compliance',
      icon: 'Users',
      category: 'application',
      description: 'I-9 verification dashboard with match results',
      order: 20,
      Component: I9UserView,
      ConfigComponent: I9AdminView,
    },
  ],
})
